export default "__VITE_ASSET__aqL0Wyucvq3zDdADMWusEg__"